import { ArticlesApi } from "../api/articleApi";
import { ObjectUtils } from "../utils/object-utils";
export class ArticleService {
    constructor() {
        this.articlesApi = new ArticlesApi();
    }
    getArticle(id) {
        return this.articlesApi.get(id);
    }
    save(article) {
        let art = ObjectUtils.removeProperty(article, 'route', true);
        art = ObjectUtils.removeProperty(art, 'articleCategoryIndices', true);
        art = ObjectUtils.removeProperty(art, 'articleTagIndices', true);
        return this.articlesApi.post(article.id, '', art);
    }
    searchArticlesByTitle(title, page = 0, size = 10, sort = ['id', 'asc']) {
        return this.articlesApi.search(title, page, size, sort);
    }
    /**
     * Получить связанные артиклы по id
     */
    getRelatedArticles(id) {
        return this.articlesApi.getRelated(id);
    }
}
